export default __webpack_public_path__ + "static/media/empty.7cb45491.svg";